// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-mapping {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 20px 0px 20px;
}
.user-mapping .user-mapping-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.user-mapping .user-mapping-content .user-mapping-filters {
  display: flex;
  justify-content: flex-end;
}
.user-mapping .user-mapping-content .user-mapping-filters .user-mapping-content-title {
  font-size: medium;
  color: #ff000f;
  font-weight: bold;
  font-size: 16px;
  margin-top: 25px;
}
.user-mapping .user-mapping-content .user-mapping-filters .search-assign-role-section {
  display: flex;
  flex-direction: row;
  gap: 15px;
}
.user-mapping .user-mapping-content .user-mapping-filters .search-assign-role-section .user-mapping-content-search-bar {
  min-width: 290px;
}
.user-mapping .user-mapping-content .user-mapping-filters .search-assign-role-section .assign-role-button {
  display: flex;
  margin-left: auto;
  margin-top: auto;
}
.user-mapping .user-mapping-content .user-mapping-table {
  height: 100%;
  background-color: var(--table-container-background);
  border-radius: 10px;
}
.user-mapping .user-mapping-content .user-mapping-alpha-filter .ABB_CommonUX_ToggleButton__root {
  min-width: 0px;
  background: transparent;
  border: none;
  font-weight: bold;
  font-size: 12px;
}
.user-mapping .user-mapping-content .user-mapping-alpha-filter .ABB_CommonUX_ToggleButton__root:hover {
  color: #36f;
}
.user-mapping .user-mapping-content .user-mapping-alpha-filter .ABB_CommonUX_ToggleButton__selected {
  background: transparent;
  color: #000;
}
.user-mapping .user-mapping-content .user-mapping-alpha-filter .ABB_CommonUX_ToggleButton__selected:hover {
  background: transparent;
  color: #36f;
}
.user-mapping .user-mapping-content .user-mapping-alpha-filter .ABB_CommonUX_ToggleButton__root:not(.ABB_CommonUX_ToggleButton__last):after {
  content: none;
}
.user-mapping .user-mapping-content .user-mapping-action-buttons {
  display: flex;
  justify-content: flex-end;
}
.user-mapping .user-mapping-content .user-mapping-action-buttons .cancel-button {
  border: solid 1px #3366ff;
  background-color: #fff;
  height: 30px;
  margin-right: 10px;
}
.user-mapping .user-mapping-content .user-mapping-action-buttons .cancel-button:hover {
  background-color: #dbdbdb;
  border: 2px solid #dbdbdb;
}
.user-mapping .user-mapping-content .user-mapping-action-buttons .btn-save {
  height: 30px;
  width: 93px;
}
.user-mapping .ABB_CommonUX_ToggleButtonGroup__container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
  padding: 0;
  white-space: nowrap;
  justify-content: space-between;
  margin-left: -15px;
  margin-right: -12px;
}
.user-mapping .user-mapping-table .roles-heading {
  font-size: 14px;
  font-weight: 500;
  background-color: var(--title-container-background);
  margin: 2px;
  padding: 4px 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.user-mapping .user-mapping-table .table-width {
  height: auto;
  padding: 10px;
}
.user-mapping .user-mapping-table .table-width .ag-header {
  background-color: var(--table-header-color) !important;
}
.user-mapping .user-mapping-table input[type=text] {
  padding-block: 0;
  padding-inline: 0 !important;
}
.user-mapping .user-mapping-table .tabulator-placeholder-contents {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
}
.user-mapping .user-mapping-table .tabulator .tabulator-header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  border-bottom: 2px solid;
  background-color: #fff;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
}
.user-mapping .user-mapping-table .tabulator .tabulator-tableholder {
  overflow: auto;
}
.user-mapping .user-mapping-table .tabulator-row .tabulator-cell {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding: 8px;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  border-right: 1px solid #ddd;
}
.user-mapping .loader {
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #36f;
  width: 60px;
  height: 60px; /* Safari */
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.user-mapping .tabulator-row .tabulator-cell {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding: 8px;
  vertical-align: middle;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  height: auto;
}
.user-mapping .ABB_CommonUX_Input__root.ABB_CommonUX_Input__light.ABB_CommonUX_Input__normal > .ABB_CommonUX_Input__inputWrapper {
  border-radius: 2px;
  height: 32px;
  border-radius: 4px;
  border: 2px solid var(--Border-primary-default, #dbdbdb);
  background: var(--Background-stateless-base, #fff);
}

.ABB_CommonUX_Dialog__content .delete-role-dialog {
  height: 210px;
  width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0px;
}
.ABB_CommonUX_Dialog__content .delete-role-dialog .info-icon {
  font-size: 46px;
  color: #ff0011;
  margin-bottom: -30px;
}
.ABB_CommonUX_Dialog__content .delete-role-dialog .delete-confirm-msg {
  font-size: 14px;
  margin-top: -20px;
}
.ABB_CommonUX_Dialog__content .delete-role-dialog .delete-heading {
  font-size: 16px;
  margin: 20px 0px;
}
.ABB_CommonUX_Dialog__content .btn-cancel-yes-delete-it-btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-right: 20px;
  margin-top: 20px;
  gap: 20px;
}
.ABB_CommonUX_Dialog__content .btn-cancel-yes-delete-it-btn .btn-cancel {
  color: blue;
  font-family: ABBVoice;
  font-size: 16px;
  border: none;
  margin-top: 3px;
  margin-right: 5px;
  background-color: white;
  cursor: pointer;
}
.ABB_CommonUX_Dialog__content .btn-cancel-yes-delete-it-btn .btn-yes-delete-it {
  font-family: ABBVoice;
  font-size: 14px;
  border-radius: 20px;
  border: none;
  width: 110px;
  height: 35px;
  padding: 6px 0px;
  color: rgb(255, 255, 255);
  background: #3366ff;
  cursor: pointer;
}

.ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize > div > span.ABB_CommonUX_Button__icon,
.ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize > div > span.ABB_CommonUX_Button__loadingIndicator {
  left: 5px;
  top: 7px;
}

.tabulator-tableholder .tabulator-table {
  /*height: 350px;*/
  overflow: auto;
}

.user-mapping-heading {
  position: relative !important;
  font-size: 22px !important;
  margin-top: 30px !important;
  text-transform: capitalize !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 2px;
  position: relative;
  width: 540px;
  max-width: 100%;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.red-border {
  border-top: 4px solid red !important;
}

.role-tag {
  display: flex;
  flex-direction: row;
  background-color: var(--Grey-10, var(--table-btn-color));
  border-radius: 60px;
  padding-left: 14px;
  margin-bottom: 5px;
  margin-top: 3px;
  height: 36px;
}

.single-role-tag {
  display: flex;
  font-family: ABBVoice-regular;
  font-size: 12px;
  white-space: nowrap;
  align-items: center;
  color: var(--btn-text-color);
}

.close-icon {
  border: none;
  padding-right: 10px;
  color: var(--toggle-close-icon-color);
  background-color: var(--Grey-10, var(--toggle-close-icon-background));
  font-size: 15px;
  border-radius: 60px;
  font-weight: bold;
  align-items: center;
  display: flex;
  padding-bottom: 5px;
  justify-content: center;
  width: 35px;
  cursor: pointer;
}

.roles-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {
  background: #fff;
  border: 1px solid #9f9f9f;
  color: var(--alphabet-text-color) !important;
}

.ag-theme-quartz-dark {
  background: color-mix(in srgb, #ff000f, var(--ag-background-color) 97%);
}

.dYrfwz > input {
  width: 100%;
  padding: 0px 0px 0px 13px;
  border: none;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  font-size: inherit;
  font-family: inherit;
  color: var(--input-text-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/user_mapping.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAEJ;AADI;EACE,aAAA;EACA,yBAAA;AAGN;AADM;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAGR;AADM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAGR;AADQ;EACE,gBAAA;AAGV;AADQ;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAGV;AACI;EACE,YAAA;EACA,mDAAA;EACA,mBAAA;AACN;AAEM;EACE,cAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAAR;AACQ;EACE,WAAA;AACV;AAEM;EACE,uBAAA;EACA,WAAA;AAAR;AAEM;EACE,uBAAA;EACA,WAAA;AAAR;AAEM;EAGE,aAAA;AAFR;AAKI;EACE,aAAA;EACA,yBAAA;AAHN;AAIM;EACE,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAFR;AAGQ;EACE,yBAAA;EACA,yBAAA;AADV;AAIM;EACE,YAAA;EACA,WAAA;AAFR;AAME;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAJJ;AAOI;EACE,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AALN;AAOI;EACE,YAAA;EACA,aAAA;AALN;AAMM;EACE,sDAAA;AAJR;AAOI;EACE,gBAAA;EACA,4BAAA;AALN;AAOI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AALN;AAOI;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AALN;AAOI;EACE,cAAA;AALN;AAOI;EACE,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;AALN;AAQE;EACE,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA,EACA,WAAA;EACA,kCAAA;AANJ;AAgBE;EACE;IACE,uBAAA;EANJ;EAQE;IACE,yBAAA;EANJ;AACF;AAQE;EACE,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AANJ;AAQE;EAEE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,wDAAA;EACA,kDAAA;AAPJ;;AAWE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AARJ;AASI;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AAPN;AASI;EACE,eAAA;EACA,iBAAA;AAPN;AASI;EACE,eAAA;EACA,gBAAA;AAPN;AAUE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AARJ;AASI;EACE,WAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;AAPN;AASI;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAPN;;AAWA;;EAME,SAAA;EACA,QAAA;AAZF;;AAgBE;EACE,iBAAA;EACA,cAAA;AAbJ;;AAiBA;EACE,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,qCAAA;AAdF;;AAgBA;EACE,0BAAA;AAbF;;AAgBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAbF;;AAeA;EACE,oCAAA;AAZF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,wDAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAXF;;AAcA;EACE,aAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;AAXF;;AAeA;EACE,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,qEAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AAZF;;AAeA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAZF;;AAeA;EACE,gBAAA;EACA,yBAAA;EACA,4CAAA;AAZF;;AAeA;EACE,uEACA;AAbF;;AAgBA;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;EACA,yCAAA;AAbF","sourcesContent":[".user-mapping {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0 20px 0px 20px;\r\n  .user-mapping-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n    .user-mapping-filters {\r\n      display: flex;\r\n      justify-content: flex-end;\r\n\r\n      .user-mapping-content-title {\r\n        font-size: medium;\r\n        color: #ff000f;\r\n        font-weight: bold;\r\n        font-size: 16px;\r\n        margin-top: 25px;\r\n      }\r\n      .search-assign-role-section {\r\n        display: flex;\r\n        flex-direction: row;\r\n        gap: 15px;\r\n\r\n        .user-mapping-content-search-bar {\r\n          min-width: 290px;\r\n        }\r\n        .assign-role-button {\r\n          display: flex;\r\n          margin-left: auto;\r\n          margin-top: auto;\r\n        }\r\n      }\r\n    }\r\n    .user-mapping-table {\r\n      height: 100%;\r\n      background-color: var(--table-container-background);\r\n      border-radius: 10px;\r\n    }\r\n    .user-mapping-alpha-filter {\r\n      .ABB_CommonUX_ToggleButton__root {\r\n        min-width: 0px;\r\n        background: transparent;\r\n        border: none;\r\n        font-weight: bold;\r\n        font-size: 12px;\r\n        &:hover {\r\n          color: #36f;\r\n        }\r\n      }\r\n      .ABB_CommonUX_ToggleButton__selected {\r\n        background: transparent;\r\n        color: #000;\r\n      }\r\n      .ABB_CommonUX_ToggleButton__selected:hover {\r\n        background: transparent;\r\n        color: #36f;\r\n      }\r\n      .ABB_CommonUX_ToggleButton__root:not(\r\n          .ABB_CommonUX_ToggleButton__last\r\n        ):after {\r\n        content: none;\r\n      }\r\n    }\r\n    .user-mapping-action-buttons {\r\n      display: flex;\r\n      justify-content: flex-end;\r\n      .cancel-button {\r\n        border: solid 1px #3366ff;\r\n        background-color: #fff;\r\n        height: 30px;\r\n        margin-right: 10px;\r\n        &:hover {\r\n          background-color: #dbdbdb;\r\n          border: 2px solid #dbdbdb;\r\n        }\r\n      }\r\n      .btn-save {\r\n        height: 30px;\r\n        width: 93px;\r\n      }\r\n    }\r\n  }\r\n  .ABB_CommonUX_ToggleButtonGroup__container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    list-style-type: none;\r\n    padding: 0;\r\n    white-space: nowrap;\r\n    justify-content: space-between;\r\n    margin-left: -15px;\r\n    margin-right: -12px;\r\n  }\r\n  .user-mapping-table {\r\n    .roles-heading {\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      background-color: var(--title-container-background);\r\n      margin: 2px;\r\n      padding: 4px 10px;\r\n      border-top-right-radius: 8px;\r\n      border-top-left-radius: 8px;\r\n    }\r\n    .table-width {\r\n      height: auto;\r\n      padding: 10px;\r\n      .ag-header {\r\n        background-color: var(--table-header-color) !important;\r\n      }\r\n    }\r\n    input[type=\"text\"] {\r\n      padding-block: 0;\r\n      padding-inline: 0 !important;\r\n    }\r\n    .tabulator-placeholder-contents {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      margin-top: 200px;\r\n    }\r\n    .tabulator .tabulator-header {\r\n      position: relative;\r\n      box-sizing: border-box;\r\n      width: 100%;\r\n      border-bottom: 2px solid;\r\n      background-color: #fff;\r\n      font-weight: 700;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n    }\r\n    .tabulator .tabulator-tableholder {\r\n      overflow: auto;\r\n    }\r\n    .tabulator-row .tabulator-cell {\r\n      display: inline-block;\r\n      position: relative;\r\n      box-sizing: border-box;\r\n      padding: 8px;\r\n      vertical-align: middle;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      border-right: 1px solid #ddd;\r\n    }\r\n  }\r\n  .loader {\r\n    border: 6px solid #f3f3f3;\r\n    border-radius: 50%;\r\n    border-top: 6px solid #36f;\r\n    width: 60px;\r\n    height: 60px;\r\n    -webkit-animation: spin 2s linear infinite; /* Safari */\r\n    animation: spin 2s linear infinite;\r\n  }\r\n  @-webkit-keyframes spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n    }\r\n  }\r\n  @keyframes spin {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n  .tabulator-row .tabulator-cell {\r\n    display: inline-block;\r\n    position: relative;\r\n    box-sizing: border-box;\r\n    padding: 8px;\r\n    vertical-align: middle;\r\n    white-space: normal;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    height: auto;\r\n  }\r\n  .ABB_CommonUX_Input__root.ABB_CommonUX_Input__light.ABB_CommonUX_Input__normal\r\n    > .ABB_CommonUX_Input__inputWrapper {\r\n    border-radius: 2px;\r\n    height: 32px;\r\n    border-radius: 4px;\r\n    border: 2px solid var(--Border-primary-default, #dbdbdb);\r\n    background: var(--Background-stateless-base, #fff);\r\n  }\r\n}\r\n.ABB_CommonUX_Dialog__content {\r\n  .delete-role-dialog {\r\n    height: 210px;\r\n    width: 500px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 0px;\r\n    .info-icon {\r\n      font-size: 46px;\r\n      color: #ff0011;\r\n      margin-bottom: -30px;\r\n    }\r\n    .delete-confirm-msg {\r\n      font-size: 14px;\r\n      margin-top: -20px;\r\n    }\r\n    .delete-heading {\r\n      font-size: 16px;\r\n      margin: 20px 0px;\r\n    }\r\n  }\r\n  .btn-cancel-yes-delete-it-btn {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n    margin-bottom: 20px;\r\n    margin-right: 20px;\r\n    margin-top: 20px;\r\n    gap: 20px;\r\n    .btn-cancel {\r\n      color: blue;\r\n      font-family: ABBVoice;\r\n      font-size: 16px;\r\n      border: none;\r\n      margin-top: 3px;\r\n      margin-right: 5px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n    }\r\n    .btn-yes-delete-it {\r\n      font-family: ABBVoice;\r\n      font-size: 14px;\r\n      border-radius: 20px;\r\n      border: none;\r\n      width: 110px;\r\n      height: 35px;\r\n      padding: 6px 0px;\r\n      color: rgb(255, 255, 255);\r\n      background: #3366ff;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n}\r\n.ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize\r\n  > div\r\n  > span.ABB_CommonUX_Button__icon,\r\n.ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize\r\n  > div\r\n  > span.ABB_CommonUX_Button__loadingIndicator {\r\n  left: 5px;\r\n  top: 7px;\r\n}\r\n\r\n.tabulator-tableholder {\r\n  .tabulator-table {\r\n    /*height: 350px;*/\r\n    overflow: auto;\r\n  }\r\n}\r\n\r\n.user-mapping-heading {\r\n  position: relative !important;\r\n  font-size: 22px !important;\r\n  margin-top: 30px !important;\r\n  text-transform: capitalize !important;\r\n}\r\n.cursor-pointer {\r\n  cursor: pointer !important;\r\n}\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 2px;\r\n  position: relative;\r\n  width: 540px;\r\n  max-width: 100%;\r\n}\r\n\r\n.modal-close {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n}\r\n.red-border {\r\n  border-top: 4px solid red !important;\r\n}\r\n.role-tag {\r\n  display: flex;\r\n  flex-direction: row;\r\n  background-color: var(--Grey-10, var(--table-btn-color));\r\n  border-radius: 60px;\r\n  padding-left: 14px;\r\n  margin-bottom: 5px;\r\n  margin-top: 3px;\r\n  height: 36px;\r\n}\r\n\r\n.single-role-tag {\r\n  display: flex;\r\n  font-family: ABBVoice-regular;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  align-items: center;\r\n  color: var(--btn-text-color);\r\n  //background-color: var(--btn-background-color);\r\n}\r\n\r\n.close-icon {\r\n  border: none;\r\n  padding-right: 10px;\r\n  color:  var(--toggle-close-icon-color);\r\n  background-color: var(--Grey-10, var(--toggle-close-icon-background));\r\n  font-size: 15px;\r\n  border-radius: 60px;\r\n  font-weight: bold;\r\n  align-items: center;\r\n  display: flex;\r\n  padding-bottom: 5px;\r\n  justify-content: center;\r\n  width: 35px;\r\n  cursor: pointer;\r\n}\r\n\r\n.roles-tags {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 5px;\r\n}\r\n\r\n.ABB_CommonUX_ToggleButton__root.ABB_CommonUX_ToggleButton__light {\r\n  background: #fff;\r\n  border: 1px solid #9f9f9f;\r\n  color: var(--alphabet-text-color)!important;\r\n}\r\n\r\n.ag-theme-quartz-dark{\r\n  background: \r\n  color-mix(in srgb, #ff000f, var(--ag-background-color) 97%);\r\n}\r\n\r\n.dYrfwz > input {\r\n  width: 100%;\r\n  padding: 0px 0px 0px 13px;\r\n  border: none;\r\n  outline: none;\r\n  background-color: rgba(0, 0, 0, 0);\r\n  font-size: inherit;\r\n  font-family: inherit;\r\n  color: var(--input-text-color)!important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
